<div class="msg" [class.my]="isMy">
    <div class="msg-wrap">
        <div class="msg-content">
            <div *ngIf="x.text" class="msg-text" [innerHTML]="x.text"></div>
        </div>
        <div class="msg-foot">{{username}} ({{x.formattedCreatedAt}})</div>
    </div>
</div>
